<template>
  <div>
    <table-component
      ref="table"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >
      <table-column
        :label="$t('islamic_finance.islamic_finance_number')"
        show="islamic_finance_number"
      />
      <table-column
        :label="$t('islamic_finance.payment_date')"
        show="formattedPaymentDate"
      />
      <table-column
        :label="$t('islamic_finance.delivery_date')"
        show="formattedDeliveryDate"
      />
      <table-column v-if="userType==='funder' || userType==='auditor'" :label="$t('islamic_finance.supplier')">
        <template slot-scope="row">
          <p v-if="row.customer">
            <span v-if="row.customer.compnay_name">
              {{ row.customer.compnay_name }}
            </span>
          </p>
        </template>
      </table-column>

      <table-column :label="$t('islamic_finance.customer')">
        <template slot-scope="row">
          <p v-if="row.customer">
            <span v-if="row.customer.parent_account && row.customer.parent_account.company_name">
              {{ row.customer.parent_account.company_name }}
            </span>
          </p>
        </template>
      </table-column>

      <table-column :label="$t('invoices.amount')" sort-as="total">
        <template slot-scope="row">
          <span>{{ $t("invoices.amount") }}</span>
          <div v-html="$utils.formatMoney(row.total, row.customer.currency)" />
        </template>
      </table-column>
      <table-column :label="$t('invoices.status')" sort-as="status">
        <template v-if="row.status" slot-scope="row">
          <span> {{ $t("invoices.status") }}</span>
          <span
            v-if="row.status === 'OFFER_TO_SELL_ACCEPT'"
            :class="'status-offer-to-sell-accept'"
          >
            {{ row.status.replaceAll("_", " ") }}
          </span>
          <span
            v-else-if="row.status === 'OFFER_TO_SELL_REJECT'"
            :class="'status-offer-to-sell-reject'"
          >
            {{ row.status.replaceAll("_", " ") }}
          </span>
          <span
            v-else-if="row.status === 'NOTICE_OF_DELIVERY_ISSUED'"
            :class="'status-offer-to-sell-delivery'"
          >
            {{ row.status.replaceAll("_", " ") }}
          </span>
          <span
            v-else-if="row.status === 'AGENT_APPOINTED'"
            :class="'status-offer-to-sell-agent-appointed'"
          >
            {{ row.status.replaceAll("_", " ") }}
          </span>
          <span
            v-else-if="row.status === 'SALE_CONFIRMED'"
            :class="'status-offer-to-sell-confirmed-sale'"
          >
            {{ row.status.replaceAll("_", " ") }}
          </span>
          <span v-else-if="row.status ==='INVOICE_INFORMATION_ADDED'" :class="'status-offer-to-sell-invoice-info-added'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span v-else-if="row.status ==='INVOICE_VERIFIED'" :class="'status-offer-to-sell-invoice-verification'">
            {{ row.status.replaceAll('_', ' ') }}
          </span>
          <span
            v-else
            :class="'inv-status-' + row.status.toLowerCase()"
            v-html="row.status"
          />
        </template>
      </table-column>
      <table-column
        :label="$t('invoices.invoice_number')"
        show="invoice_number"
      />
      <table-column
        :label="$t('funders.added_on')"
        sort-as="created_at"
        show="formattedCreatedAt"
      />
    </table-component>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: { default: '', type: String }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') === 'auditor') {
      this.userType = 'auditor'
    }
  },
  methods: {}
}
</script>
<style scoped>
.table-component {
  min-height: 0px !important;
}
</style>
